<template class="form-dados-cadastrais">
  <div class="telaCondicoes">
    <v-form
      ref="segurosAnteriores"
      @submit.prevent
      v-model="validSegurosAnteriores"
    >
      <v-container class="pt-0">
        <div class="header-step">
          <h3>Condições do segurado</h3>
          <p>Conte-nos um pouco do histórico da empresa.</p>
        </div>
        <v-layout row wrap>
          <v-flex xs12 sm5>
            <h4 class="primary--text">Já possui seguro atualmente?</h4>
            <v-radio-group
              :disabled="disabledCondicoes"
              required
              v-model="dadosSeguroAnterior.container"
              row
            >
              <v-radio
                color="primary"
                id="possuiSeguro"
                ref="possuiSeguro"
                label="Não"
                :value="false"
                checked
              ></v-radio>
              <v-radio
                color="primary"
                id="naoPossuiSeguro"
                ref="naoPossuiSeguro"
                label="Sim"
                :value="true"
              ></v-radio>
            </v-radio-group>
          </v-flex>

        </v-layout>
        <v-layout v-show="dadosSeguroAnterior.container == true" row wrap>
          <v-flex xs12 sm5>
            <v-text-field
              :disabled="disabledCondicoes"
              label="Seguradora atual"
              id="seguroAtual"
              ref="txtValorMedioMercadoria"
              :rules="regras.seguradora"
              v-model="dadosSeguroAnterior.seguradora"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm5>
            <v-text-field
              :disabled="disabledCondicoes"
              label="Corretora atual"
              id="corretoraAtual"
              v-model="dadosSeguroAnterior.corretora"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm5>
            <v-menu
              ref="modalDataVigencia"
              lazy
              :close-on-content-click="false"
              v-model="mostrarGridContato"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              min-width="290px"
              :return-value.sync="modelFormatado.data"
              :rules="regras.notNull"
              required

            >
              <v-text-field
                :disabled="disabledCondicoes"
                slot="activator"
                label="Vencimento da apólice"
                v-model="textEdit"
                append-icon="event"
                id="txtNovoSeguroDataVigencia"
                required
                clearable
                readonly
                :rules="regras.notNull"
              ></v-text-field>
              <v-date-picker
                :disabled="disabledCondicoes"
                v-model="dadosSeguroAnterior.vencimento"
                :min="new Date().toISOString().substring(0, 10)"
                locale="pt-br"
                :rules="regras.notNull"
                required

              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 md12>
            <p class="texto-inform">Informe as condições aplicadas no seguro atual conforme o ramo</p>
            <v-btn
              :disabled="disabledCondicoes"

              color="secondary"
              class="ml-0"
              @click="dialogAdicionarRamo = true"
            >
              ADICIONAR RAMO
            </v-btn>
          </v-flex>
          <v-flex md12 xs12 class="mb-2">
            <v-data-table
              :items="dadosSeguroAnterior.ramos"
              :headers="headersRamo"
              class="elevation-0"
              hide-actions
              v-show="dadosSeguroAnterior.ramos.length > 0"
            >
              <template v-slot:no-data >
                <p></p>
              </template>
              <template v-slot:items="props">
                <td>
                  {{ramoTransportador ? buscarTitulo(props.item.idTipoRamo, listaRamosTransportador)
                  : buscarTitulo(props.item.idTipoRamo, listaRamosEmbarcador)}}
                </td>
                <td>{{formatMoney(props.item.valorMedioAverbadoMes)}}</td>
                <td>{{props.item.valorTaxa}}</td>
                <td>{{formatMoney(props.item.limiteResponsabilidade)}}</td>
                <td>{{props.item.posFranquia.toString()}}</td>
                <td>{{formatMoney(props.item.premioMinimoMensal)}}</td>
                <td>{{formatMoney(props.item.isUltimaFatura)}}</td>
                <td>{{formatMoney(props.item.premioUltimaFatura)}}</td>
                <td>{{formatMoney(props.item.premioUltimos12Meses)}}</td>
                <td>
                  <v-icon
                    small
                    class="mr-2"
                    :disabled="disabledCondicoes"
                    @click="editarItemRamo(props.item)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    small
                    :disabled="disabledCondicoes"
                    @click="deletarItemRamo(props.item)"
                  >
                    delete
                  </v-icon>
                </td>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 md12>
            <p class="texto-inform">Informe as regras de gerenciamento de risco aplicadas no seguro atual</p>
            <v-btn
              :disabled="disabledCondicoes"
              color="secondary"
              class="ml-0"
              @click="dialogAdicionarRegra = true"
            >
              ADICIONAR REGRA
            </v-btn>
          </v-flex>
          <v-flex md12 xs12 class="mb-2">
            <v-data-table
              :items="dadosSeguroAnterior.regrasGerenciamento"
              :headers="headersRegras"
              class="elevation-0"
              hide-actions
              v-show="dadosSeguroAnterior.regrasGerenciamento.length > 0"
            >
              <template v-slot:no-data >
                <p></p>
              </template>
              <template v-slot:items="props">
                <td>{{ props.item.descricao }}</td>
                <td>
                  <v-icon
                    small
                    class="mr-2"
                    :disabled="disabledCondicoes"
                    @click="editarItemRegra(props.item)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    small
                    :disabled="disabledCondicoes"
                    @click="deletarItemRegra(props.item)"
                  >
                    delete
                  </v-icon>
                </td>
              </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout v-show="dadosSeguroAnterior.container == true && ramoTransportador == false">
          <v-flex xs12 sm5 pb-0>
            <h4 class="primary--text">
              Contrata alguma cobertura?
            </h4>
            <v-radio-group
              :disabled="disabledCondicoes"
              v-model="dadosSeguroAnterior.contrataCobertura"
              row
            >
              <v-radio
                color="primary"
                id="contrataCoberturaNao"
                ref="contrataCoberturaNao"
                label="Não"
                :value="false"
                checked="checked"
                default
              />
              <v-radio
                color="primary"
                id="contrataCoberturaSim"
                ref="contrataCoberturaSim"
                label="Sim"
                :value="true"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout v-show="dadosSeguroAnterior.contrataCobertura == true">
          <v-flex xs12 sm5 xl3 pt-0 pb-0>
            <v-select
              :disabled="disabledCondicoes"
              label="Tipo de cobertura"
              :items="listaCoberturas"
              v-model="dadosSeguroAnterior.idCobertura"
              item-text="titulo"
              item-value="id"
              :rules="regras.notNull"
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout v-show="dadosSeguroAnterior.container == true && ramoTransportador == false">
          <v-flex pt-0>
            <v-checkbox :disabled="disabledCondicoes" v-model="dadosSeguroAnterior.possuiCoberturaRoubo">
              <span slot="label" class="black--text">Possui cobertura contra roubo</span>
            </v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm5>
            <h4 class="primary--text">
              Houve ocorrência de sinistro ou roubo nos últimos 24 meses?
            </h4>
            <v-radio-group
              :disabled="disabledCondicoes"
              required
              v-model="dadosSeguroAnterior.ocorreuSinistro"
              row
            >
              <v-radio
                color="primary"
                id="ultimos12MesesRouboNao"
                ref="ultimos12MesesRouboNao"
                label="Não"
                :value="false"
                checked="checked"
                default
              />
              <v-radio
                color="primary"
                id="ultimos12MesesRouboSim"
                ref="ultimos12MesesRouboSim"
                label="Sim"
                :value="true"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-layout row wrap>
            <v-flex v-show="dadosSeguroAnterior.ocorreuSinistro" xs12 md3>
              <v-btn color="secondary" @click="dialogSinistro = true" :disabled="disabledCondicoes">
                Adicionar evento
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout row wrap>
          <v-layout row wrap>
            <v-flex v-show="dadosSeguroAnterior.ocorreuSinistro" xs12 md12>
              <v-data-table
                :headers="headers"
                :items="dadosSeguroAnterior.sinistros"
                class="pl-3"
                hide-details
              >
              <template v-slot:no-data>
                <p></p>
              </template>
                <template v-slot:items="props">
                  <td> {{buscarTitulo(props.item.idTipoEvento, listaEventos)}}</td>
                  <td>
                    {{ formatMoney(props.item.valorPrejuizo) }}
                  </td>
                  <td>
                    {{ props.item.mercadoria.descricao }}
                  </td>
                  <td>{{ toLocaleDateString(props.item.data) }}</td>
                  <td>
                    <v-icon small class="mr-2" @click="editItem(props.item)" :disabled="disabledCondicoes">
                      edit
                    </v-icon>
                    <v-icon small @click="deleteItem(props.item)" :disabled="disabledCondicoes">
                      delete
                    </v-icon>
                  </td>
                </template>

              </v-data-table>
            </v-flex>
          </v-layout>
        </v-layout>


        <v-layout>
          <v-flex xs12 sm5>
            <h4 class="primary--text">
              Contrata algum serviço?
            </h4>
            <v-radio-group
              :disabled="disabledCondicoes"
              required
              v-model="dadosSeguroAnterior.existeContrataServico"
              row
            >
              <v-radio
                color="primary"
                id="contrataServicoNao"
                ref="contrataServicoNao"
                label="Não"
                :value="false"
                checked="checked"
                default
              />
              <v-radio
                color="primary"
                id="contrataServicoSim"
                ref="contrataServicoSim"
                label="Sim"
                :value="true"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-layout row wrap>
            <v-flex v-show="dadosSeguroAnterior.existeContrataServico" xs12 md3>
              <v-btn :disabled="disabledCondicoes" color="secondary" @click="dialogServico = true" >
                Adicionar Serviço
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout row wrap>
          <v-layout row wrap>
            <v-flex v-show="dadosSeguroAnterior.existeContrataServico" xs12 md12>
              <v-data-table
                :headers="headersServico"
                :items="dadosSeguroAnterior.contrataServicos"
                class="pl-3"
                hide-details
              >
              <template v-slot:no-data>
                <p></p>
              </template>
                <template v-slot:items="props">
                  <td class="pl-5">{{buscarTitulo(
                    props.item.idTipoServicoContratado,
                    camposServico.tipoServicoList)
                    }}</td>
                  <td class="pl-5">
                    {{ props.item.gerenciadoraAtual }}
                  </td>
                  <td class="pl-5">
                    {{ formatMoney(props.item.valorUltimaFatura) }}
                  </td>
                  <td class="pl-5">
                    {{ formatMoney(props.item.valorMedioFaturaMensal) }}
                  </td>
                  <td class="justify-center layout px-0 pr-5">
                    <v-icon small class="mr-2" @click="editItemServico(props.item)" :disabled="disabledCondicoes">
                      edit
                    </v-icon>
                    <v-icon small @click="deleteItemServico(props.item)" :disabled="disabledCondicoes">
                      delete
                    </v-icon>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-layout>


      </v-container>
      <v-layout row>
        <v-flex xs12>
          <v-btn flat @click="$emit('voltarSeguroAnterior', true)" color="primary">
              Voltar
          </v-btn>
          <v-btn
            :disabled="passoValido()"
            @click="sendDatatoParent"
            type="submit"
            color="primary"
          >
            Proximo
          </v-btn>
        </v-flex>
        <v-flex xs12 md4>

        </v-flex>
      </v-layout>
      <v-snackbar
        :timeout="3000"
        :color="snackbar.sucesso ? 'success' : 'error'"
        multi-line
        v-model="snackbar.visivel"
      >
        {{ snackbar.mensagem }}
        <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
      </v-snackbar>
    </v-form>
    <v-dialog v-model="dialogSinistro" persistent width="350">
      <v-form ref="formEvento" v-model="validDadosSinistro">
        <v-card>
          <v-toolbar card class="toolbar-custom">
            <v-card-title class="title-dialog-custom">
              {{ editedIndex > -1 ? "Editar" : "Adicionar" }} evento
            </v-card-title>
          </v-toolbar>
          <v-container class="container-special" grid-list-md>
            <v-layout row wrap>
              <v-flex>
                <v-select
                  label="Tipo de evento"
                  :items="listaEventos"
                  v-model="sinistroModel.idTipoEvento"
                  item-text="titulo"
                  item-value="id"
                  :rules="regras.notNull"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  ref="valorPrejuizo"
                  v-model="valorPrejuizoFiltrado"
                  label="Valor do prejuízo"
                  required
                  v-money="maskComputed.maskMoney"
                  :rules="regras.notNull"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-autocomplete
                  v-model="sinistroModel.mercadoria"
                  label="Mercadorias"
                  :items="lstMercadorias"
                  item-text="descricao"
                  return-object
                  :rules="regras.notNull"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex>
                <v-menu
                  ref="menu"
                  v-model="menu1"
                  :close-on-content-click="false"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  min-width="290px"
                  :return-value.sync="modelFormatado.data"
                  :rules="regras.notNull"
                  required
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="textInicioModal"
                      label="Data do evento"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      required
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="sinistroModel.data"
                    no-title
                    scrollable
                    :rules="regras.notNull"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 md4>
                <v-btn flat color="primary" @click="tratamentoFecharDialogSinistro" >
                  Cancelar
                  </v-btn>
              </v-flex>
              <v-flex xs12 offset-md4 md4>
                <v-btn
                  :disabled="!validDadosSinistro"
                  class="primary"
                  @click="salvarSinistros"
                >
                  Salvar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialogAdicionarRamo" persistent width="300">
      <v-card>
        <v-card-title class="titulo-modal">
          {{ editedIndexRamo > -1 ? "Editar" : "Adicionar" }} ramo
        </v-card-title>
        <v-card-text class="pt-0">
          <v-form ref="adicionarRamoForm" v-model="adicionarRamoForm">
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-select
                  :items="ramoTransportador ? listaRamosTransportador : listaRamosEmbarcador"
                  label="Ramo"
                  item-text="titulo"
                  item-value="id"
                  v-model="ramoModel.idTipoRamo"
                  :rules="regras.notNull"
                ></v-select>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Valor médio averbado ao mês"
                  v-model="valorTransportadoMesFiltrado"
                  v-money="maskComputed.maskMoney"
                  ref="valorMedioAverbadoMes"
                  :rules="regras.precisaTerValor"
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs6>
                <v-radio-group
                  v-model="ramoModel.idTipoTaxa"
                  :rules="regras.notNull"
                >
                  <v-radio label="Taxa" value="1"></v-radio>
                  <v-radio label="Desconto" value="2"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex md6 xs6>
                <v-text-field
                  v-model="ramoModel.valorTaxa"
                  :label="parseInt(ramoModel.idTipoTaxa) == tipoTaxaEnumCpt.tipoTaxa.TAXA ?  'Valor da Taxa' : 'Valor do Desconto'"
                  :rules="regras.notNull"
                  type="number"
                  @keypress="limitaCasasDecimais"
                  suffix="%"
                  :disabled="!ramoModel.idTipoTaxa"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Limite de responsabilidade"
                  v-model="limiteResponsabilidadeFiltrado"
                  v-money="maskComputed.maskMoney"
                  ref="limiteResponsabilidade"
                  :rules="regras.precisaTerValor"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-select
                  label="POS/Franquia"
                  v-model="ramoModel.posFranquia"
                  placeholder="Selecione uma opção"
                  :items="listaFranquias"
                  ref="posFranquia"
                  item-text="titulo"
                  item-value="titulo"
                  :counter-value="valorContadorComputed"
                  :menu-props="menuProps"
                  multiple
                  chips
                  deletable-chips
                  @input="ajustaOpcoes"
                ></v-select>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Prêmio mínimo mensal"
                  v-model="premioMinimoMensalFiltrado"
                  v-money="maskComputed.maskMoney"
                  ref="premioMinimoMensal"
                  :rules="regras.precisaTerValor"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="IS última fatura"
                  v-model="isUltimaFaturaFiltrado"
                  v-money="maskComputed.maskMoney"
                  ref="isUltimaFatura"
                  :rules="regras.precisaTerValor"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Prêmio última fatura"
                  v-model="premioUltimaFaturaFiltrado"
                  v-money="maskComputed.maskMoney"
                  ref="premioUltimaFatura"
                  :rules="regras.precisaTerValor"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Prêmio últimos 12 meses"
                  v-model="premioUltimos12MesesFiltrado"
                  v-money="maskComputed.maskMoney"
                  ref="premioUltimos12Meses"
                  :rules="regras.precisaTerValor"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions class="flex-actions-ramo">
          <v-btn color="primary" flat @click="tratamentoFecharDialogRamo">Cancelar</v-btn>
          <v-btn color="primary" @click="tratamentoSalvarRamo" :disabled="!adicionarRamoForm">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAdicionarRegra" persistent width="500">
      <v-form ref="formRegra" v-model="validRegraGerenciamento">
        <v-card>
          <v-toolbar card class="toolbar-custom">
            <v-card-title class="titulo-modal">
              {{ editedIndexRegra > -1 ? "Editar" : "Adicionar" }} Regra
            </v-card-title>
          </v-toolbar>
          <v-container class="container-special" grid-list-md>
            <v-layout row wrap>
              <v-flex class="textblack">
                Descrição
                <v-textarea
                  :disabled="disabledCondicoes"
                  v-model="regraGerenciamentoModel.descricao"
                  outline
                  required
                  :rules="[regras.length(500)]"
                  counter="500"
                >
                </v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs12 md4>
                  <v-btn flat color="primary" @click="tratamentoFecharDialogRegra" >
                    Cancelar
                    </v-btn>
                </v-flex>
                <v-flex xs12 offset-md4 md4>
                  <v-btn
                    :disabled="!validRegraGerenciamento || !regraGerenciamentoModel.descricao"
                    class="primary"
                    @click="salvarRegra"
                  >
                    Salvar
                  </v-btn>
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialogServico" persistent width="350">
      <v-form ref="formServico" v-model="validDadosServico">
        <v-card>
          <v-toolbar card class="toolbar-custom">
            <v-card-title class="title-dialog-custom">
              {{ editedIndex > -1 ? "Editar" : "Adicionar" }} servico
            </v-card-title>
          </v-toolbar>
          <v-container class="container-special" grid-list-md>
            <v-layout row wrap>
              <v-flex>
                <v-select
                  label="Tipo de servico"
                  :items="camposServico.tipoServicoList"
                  v-model="contrataServicoModel.idTipoServicoContratado"
                  item-text="titulo"
                  item-value="id"
                  required
                  :rules="regras.notNull"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  ref="gerenciadoraAtual"
                  v-model="contrataServicoModel.gerenciadoraAtual"
                  label="Gerenciadora atual"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  ref="valorUltimaFatura"
                  label="Valor última fatura"
                  v-model="valorUltimaFaturaFiltrado"
                  v-money="maskComputed.maskMoney"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  ref="valorMedioFaturaMensal"
                  label="Valor médio mensal"
                  v-model="valorMedioFaturaMensalFiltrado"
                  v-money="maskComputed.maskMoney"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 md4>
                <v-btn flat color="primary" @click="tratamentoFecharDialogServico" >
                  Cancelar
                  </v-btn>
              </v-flex>
              <v-flex xs12 offset-md4 md4>
                <v-btn
                  :disabled="!validDadosServico"
                  class="primary"
                  @click="salvarServico"
                >
                  Salvar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-form>
    </v-dialog>

  </div>
</template>

<script>
import CustomFormat from '@/helpers/custom-format';
import mask from "@/helpers/mask";
import {VMoney} from 'v-money';
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado";
import tipoTaxaEnum from "@/helpers/tipo-taxa-enum.js";
import TipoCliente from '@/helpers/tipo-cliente'

export default {
  name: "QARCondicoesSegurado",
  directives: {
    money: VMoney
  },
  props: {
    protocolo: String,
    dadosQuestionarioCompleto: {
      type: Object,
      required: false
    },
    dadosCadastrais: {
      type: Object,
      required: false,
    }
  },
  data: () => ({
    listaRamosTransportador: [],
    listaRamosEmbarcador: [],
    ramoTransportador: false,
    editedIndexRamo: -1,
    editedIndexRegra: -1,
    maximo: 3,
    defaultItemRamo: {
      idTipoRamo: null,
      valorMedioAverbadoMes: null,
      limiteResponsabilidade: null,
      posFranquia: null,
      premioMinimoMensal:null,
      isUltimaFatura: null,
      premioUltimaFatura: null,
      premioUltimos12Meses: null,
      idTipoTaxa: null,
      valorTaxa: null,
    },
    menuProps: {
      disabled: false
    },
    dialogAdicionarRamo: false,
    adicionarRamoForm: true,
    dialogAdicionarRegra: false,
    taxaOuDescontoRoubo: false,
    dadosSeguroAnterior: {
      container: false,
      vencimento: null,
      ocorreuSinistro: false,
      existeContrataServico: false,
      contrataCobertura: false,
      possuiCoberturaRoubo: false,
      idCobertura: null,
      corretora: null,
      seguradora: null,
      contrataServicos: [],
      sinistros: [],
      ramos:[],
      regrasGerenciamento: []
    },
    dateInicio: null,
    validSegurosAnteriores: false,
    validDadosSinistro: true,
    validDadosServico: true,
    validRegraGerenciamento: true,
    dialogSinistro: false,
    dialogServico: false,
    dateFim: new Date().toISOString().slice(0, 10),
    fluvial: false,
    ramoModel: {
      idTipoRamo: null,
      valorMedioAverbadoMes: null,
      limiteResponsabilidade: null,
      posFranquia: [],
      premioMinimoMensal: null,
      isUltimaFatura: null,
      premioUltimaFatura: null,
      premioUltimos12Meses: null,
      idTipoTaxa: null,
      valorTaxa: null,
    },
    errorMessages: {
      txtPosFranquia: []
    },
    valorTransportadoMesFiltrado: null,
    limiteResponsabilidadeFiltrado: null,
    premioMinimoMensalFiltrado: null,
    premioUltimaFaturaFiltrado: null,
    premioUltimos12MesesFiltrado: null,
    valorUltimaFaturaFiltrado: null,
    valorMedioFaturaMensalFiltrado: null,
    isUltimaFaturaFiltrado: null,
    valorPrejuizoFiltrado: null,
    regraGerenciamentoModel: {
      descricao: null
    },
    sinistroModel: {
      idTipoEvento: null,
      valorPrejuizo: null,
      mercadoria: null,
      data: new Date().toISOString().slice(0, 10),
    },
    contrataServicoModel: {
        idTipoServicoContratado: null,
        gerenciadoraAtual: null,
        valorUltimaFatura: null,
        valorMedioFaturaMensal: null
    },
    camposServico: {
      tipoServicoList: [
      { id: 1, titulo: "Cadastro" },
      { id: 2, titulo: "Monitoramento" },
      { id: 3, titulo: "Outro" }
    ],
    classeList: new Array(11).fill({}).map((_, index) => ({
      id: index,
      titulo: `${index}`
    })),
    },
    lstMercadorias: [],
    listaEventos: [],
    listaFranquias: [],
    listaCoberturas: [],
    menu1: false,
    mostrarGridContato: false,
    editedIndex: -1,
    modelFormatado: {
      data: ""
    },
    defaultItem: {
      idTipoServicoContratado: null,
      gerenciadoraAtual: null,
      tipoEvento: null,
      valorPrejuizo: null,
      mercadorias: null,
      vencimentoApolice: new Date().toISOString().slice(0, 10),
    },
    modalideAtuacao: [
      { id: 1, titulo: "Embarcador" },
      { id: 2, titulo: "Transportador" },
      { id: 3, titulo: "Outra" }
    ],
    categoriaContato: [
      { id: 1, titulo: "Empresa" },
      { id: 2, titulo: "Responsável" },
      { id: 3, titulo: "Proprietário" }
    ],
    headers: [
      { text: "Tipo de evento", value: "tipoEvento" },
      { text: "Valor do prejuízo", value: "valorPrejuizo" },
      { text: "Mercadorias", value: "mercadoria" },
      { text: "Data do evento", value: "data" },
      { text: "Ações", value: "actions", sortable: false }
    ],
    headersServico: [
      { text: "Serviço", value: "tipoServico" },
      { text: "Gerenciadora atual", value: "gerenciadoraAtual" },
      { text: "Valor última fatura", value: "valoUltimaFatura" },
      { text: "Valor médio mensal", value: "valorMedioFaturaMensal" },
      { text: "Ações", value: "actions", sortable: false },
    ],
    headersRamo: [
      {text: "Ramo", value: "ramo", sortable: false},
      {text: "Valor Médio averbado ao mes", value: "valorMedioAverbadoMes", sortable: false},
      {text: "Valor da taxa ou desconto", value: "ramo", sortable: false},
      {text: "Limite de responsabilidade", value: "limiteResponsabilidade", sortable: false},
      {text: "POS/Franquia", value: "posFranquia", sortable: false},
      {text: "Prêmio mínimo mensal", value: "premioMinimoMensal", sortable: false},
      {text: "IS última fatura", value: "isUltimaFatura", sortable: false},
      {text: "Prêmio última fatura", value: "premioUltimaFatura", sortable: false},
      {text: "Prêmio últimos 12 meses", value: "premioUltimos12Meses", sortable: false},
      {text: "Ações", value: "acoes", sortable: false},
    ],
    headersRegras: [
      { text: "Descrição", value: "descricao" },
      { text: "Ações", value: "acoes", sortable: false, width: "100px" }
    ],
    regras: {
      precisaTerValor: [
        v => ( v != "R$ 0,00"  && !!v) || 'Valor nao pode ser 0 e precisa estar preenchido'
      ],
      franquiaVazio: [
        v => (!!v && v.length > 0) || 'Você não pode deixar este campo em branco',
      ],
      length: len => v =>
        (v || "").length <= len ||
        `Número máximo de caracteres ultrapassado, requer no máximo ${len} caracteres.`,
      notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      cnpj: [v => !!String(v).match(/^[A-Za-z0-9]{12}\d{2}$/) ||"Valor incorreto"],
      apoliceAnteriores: [
          v => !!v || 'Você não pode deixar este campo em branco'
      ],
      seguradora: [
        v => !!v || 'Você não pode deixar este campo em branco'
      ],
      corretora: [
        v => (!v || (!!v && (v.length == 0 || v.length <= 255))) || 'O campo deve ter no máximo 255 caracteres'
      ],
      taxaDescontoAnteriorRadio: [
        v => !!v || 'Você não pode deixar este campo em branco'
      ],
      ocorreuSinistro: [
        v => !!v || 'Você não pode deixar este campo em branco'
      ],
      porcentagemTaxa: [
        v => (CustomFormat.removePercentFormat(v) >= 0) || 'Você precisa informar um valor válido',
            v => (CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um valor válido',
            v => (   (/^(100)$/g.test(v) && v.length < 8 )
                  || (/^(100\,\d{1,3})$/g.test(v) && v.length < 8 )
                  || (/^(\d{2})$/g.test(v) && v.length < 7)
                  || (/^(\d{2}\,\d{1,3})$/g.test(v) && v.length < 7)
                  || (/^(\d{1})$/g.test(v) && v.length < 6)
                  || (/^(\d{1}\,\d{1,3})$/g.test(v) && v.length < 6) )
                  || 'Você precisa informar um valor válido'
      ],
      porcentagemDesconto: [
        v => (CustomFormat.removePercentFormat(v) >= 0) || 'Você precisa informar um valor válido',
        v => (CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um valor válido',
        v => (   (/^(100)$/g.test(v) && v.length < 8 )
              || (/^(100\,\d{1,2})$/g.test(v) && v.length < 8 )
              || (/^(\d{2})$/g.test(v) && v.length < 6)
              || (/^(\d{2}\,\d{1,2})$/g.test(v) && v.length < 6)
              || (/^(\d{1})$/g.test(v) && v.length < 5)
              || (/^(\d{1}\,\d{1,2})$/g.test(v) && v.length < 5) )
              || 'Você precisa informar um valor válido'
      ],
      valorPrejuizo: [
        v => CustomFormat.removeMoneyFormat(v) > 0 || "Você precisa informar um valor válido"
      ]
    },
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    },
    textoInicio: null
  }),

  watch: {
    valorPrejuizoFiltrado(val) {
      if(val != null && val != undefined && val!= "") {
        this.sinistroModel.valorPrejuizo = CustomFormat.removeMoneyFormat(val);
      }
    },
    valorTransportadoMesFiltrado(val) {
      if(val != null && val != undefined && val!= "") {
          this.ramoModel.valorMedioAverbadoMes = CustomFormat.removeMoneyFormat(val);
      }
    },
    limiteResponsabilidadeFiltrado(val) {
      if(val != null && val != undefined && val!= "") {
          this.ramoModel.limiteResponsabilidade = CustomFormat.removeMoneyFormat(val);
      }
    },
    premioMinimoMensalFiltrado(val) {
      if(val != null && val != undefined && val!= "") {
          this.ramoModel.premioMinimoMensal = CustomFormat.removeMoneyFormat(val);
      }
    },
    isUltimaFaturaFiltrado(val) {
      if(val != null && val != undefined && val!= "") {
          this.ramoModel.isUltimaFatura = CustomFormat.removeMoneyFormat(val);
      }
    },
    premioUltimaFaturaFiltrado(val) {
      if(val != null && val != undefined && val!= "") {
          this.ramoModel.premioUltimaFatura = CustomFormat.removeMoneyFormat(val);
      }
    },
    premioUltimos12MesesFiltrado(val) {
      if(val != null && val != undefined && val!= "") {
          this.ramoModel.premioUltimos12Meses = CustomFormat.removeMoneyFormat(val);
      }
    },
    valorUltimaFaturaFiltrado(val) {
      if(val != null && val != undefined && val!= "") {
          this.contrataServicoModel.valorUltimaFatura = CustomFormat.removeMoneyFormat(val);
      }
    },
    valorMedioFaturaMensalFiltrado(val) {
      if(val != null && val != undefined && val!= "") {
          this.contrataServicoModel.valorMedioFaturaMensal = CustomFormat.removeMoneyFormat(val);
      }
    },
    dadosQuestionarioCompleto(val) {
      if(val.id != null  &&  val.id != undefined) {
        this.buscarTransportadora(val.idTransportadora);
        this.dadosSeguroAnterior.container = val.segurosAnteriores.apolicesAnteriores;
        this.dadosSeguroAnterior.vencimento = val.segurosAnteriores.vencimento;
        this.dadosSeguroAnterior.seguradora = val.segurosAnteriores.seguradora;
        this.dadosSeguroAnterior.corretora = val.segurosAnteriores.corretora;
        this.dadosSeguroAnterior.contrataCobertura = val.segurosAnteriores.contrataCobertura;
        this.dadosSeguroAnterior.idCobertura = val.segurosAnteriores.idCobertura;
        this.dadosSeguroAnterior.possuiCoberturaRoubo = val.segurosAnteriores.possuiCoberturaRoubo;
        this.dadosSeguroAnterior.ocorreuSinistro = val.segurosAnteriores.ocorreuSinistro;
        this.dadosSeguroAnterior.existeContrataServico = val.segurosAnteriores.existeContrataServico;
        this.dadosSeguroAnterior.regrasGerenciamento = val.segurosAnteriores.regraGerenciamento;
        if(this.dadosSeguroAnterior.ocorreuSinistro) {
          this.dadosSeguroAnterior.sinistros = val.segurosAnteriores.sinistros
        }
        if(val.segurosAnteriores.existeRamosSegurado) {
          this.dadosSeguroAnterior.ramos = val.segurosAnteriores.ramosSegurado;
        }
        if(this.dadosSeguroAnterior.existeContrataServico) {
          this.dadosSeguroAnterior.contrataServicos = val.segurosAnteriores.contrataServicos
        }
      }
    },
    dadosCadastrais(val) {
      if(val.transportadora.tipoCliente.id != null && val.transportadora.tipoCliente.id != undefined) {
        if (val.transportadora.tipoCliente.id == this.tipoClienteComputed.tipoCliente.TRANSPORTADOR) {
            this.ramoTransportador = true;
        }
      }
    },
    'dadosSeguroAnterior.container'() {
      if(this.dadosSeguroAnterior.container == false) {
        return this.limparCampos()
      }
    },
    'sinistroModel.data': function (val) {
        this.sinistroModel.data == val ? CustomFormat.toLocaleDateString(val) : '';
    },
    'dadosSeguroAnterior.ocorreuSinistro': function (val) {
      if (this.dadosSeguroAnterior.ocorreuSinistro == false) {
        return this.limparCamposSinistro()
      }
    },
    'dadosSeguroAnterior.existeContrataServico'() {
      if(this.dadosSeguroAnterior.existeContrataServico == false) {
        return this.limparCamposServico()
      }
    },
    'dadosSeguroAnterior.contrataCobertura'() {
      if (this.dadosSeguroAnterior.contrataCobertura == false) {
        return this.dadosSeguroAnterior.idCobertura = null
      }
    }
  },
  computed: {
    valorContadorComputed() {
      let total = 0
      if (this.ramoModel.posFranquia && this.ramoModel.posFranquia.length > 0) {
        const itemSelecionado = this.ramoModel.posFranquia.map((titulo) => {
          return this.listaFranquias.find((element) => element.titulo === titulo)
        })
        total = itemSelecionado.reduce(function(acc, cur) {
          return acc + ((cur.count) ? cur.count : 1 );
        }, 0)
      }
      return total;
    },
    tipoTaxaEnumCpt() {
      return tipoTaxaEnum;
    },
    tipoClienteComputed: function () {
      return TipoCliente;
    },
    disabledCondicoes() {
      return this.protocolo != null || this.dadosQuestionarioCompleto.id != null;
    },
    textEdit() {
      if (this.dadosSeguroAnterior.vencimento) {
        return new Date(this.dadosSeguroAnterior.vencimento).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
      }
    },
    maskComputed: function() {
      return mask;
    },
    textInicioModal() {
      return new Date(this.sinistroModel.data).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        day: "numeric",
        month: "long",
        year: "numeric",
      });

    },
  },
  mounted() {
    this.$refs.adicionarRamoForm.reset();
    this.buscarTipoCobertura();
    this.buscarTipoRamo();
    this.carregaMercadorias();
    this.buscarTipoEvento();
    this.buscaTipoFranquia();
  },
  methods: {
    buscarTipoCobertura() {
      axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/tipo-solicitacao/tipoCobertura`, {
          headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      }).then(response => {
        this.listaCoberturas = response.data;
      });
    },
    buscarTipoRamo() {
      axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/tipo-solicitacao/tipoRamo`, {
          headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      }).then(response => {
        this.listaRamosTransportador = response.data.filter(this.retornaRamosTransportador);
        this.listaRamosEmbarcador = response.data.filter(this.retornaRamosEmbarcador);
      });
    },
    carregaMercadorias: function () {
      if (axios) {
        axios.get(`${process.env.URL_MERCADORIAMS}/v1/no-auth/buscaTodasMercadorias`)
        .then((response) => {
          const data = response.data;
          if (data) {
            this.lstMercadorias = data;
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    },
    buscarTipoEvento() {
      axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/tipo-solicitacao/tipoEvento`, {
          headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      }).then(response => {
        this.listaEventos = response.data
      });
    },
    buscaTipoFranquia() {
      axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/tipo-solicitacao/tipoFranquia`, {
          headers: {
              'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
      }).then(response => {
        this.listaFranquias = response.data
      });
    },
    buscarTransportadora(val) {
      axios.get(`${process.env.URL_TRANSPORTADORAMS}/v1/buscaTransportadora?id=${val}`, {
        headers: {
          'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      }).then(res => {
        if(res.data) {
          if (res.data.tipoCliente.id == this.tipoClienteComputed.tipoCliente.TRANSPORTADOR) {
            this.ramoTransportador = true
          }
        }
      })
    },
    retornaRamosTransportador(value) {
      if (value.id <= 4) {
        return value;
      }
    },
    retornaRamosEmbarcador(value) {
      if (value.id > 4) {
        return value;
      }
    },
    editarItemRamo(item) {
      this.editedIndexRamo = this.dadosSeguroAnterior.ramos.indexOf(item)
      this.$refs.valorMedioAverbadoMes.$el.getElementsByTagName('input')[0].value = item.valorMedioAverbadoMes.toFixed(2);
      this.$refs.limiteResponsabilidade.$el.getElementsByTagName('input')[0].value = item.limiteResponsabilidade.toFixed(2);
      this.$refs.posFranquia.$el.getElementsByTagName('input')[0].value = item.posFranquia;
      this.$refs.premioMinimoMensal.$el.getElementsByTagName('input')[0].value = item.premioMinimoMensal.toFixed(2);
      this.$refs.isUltimaFatura.$el.getElementsByTagName('input')[0].value = item.isUltimaFatura.toFixed(2);
      this.$refs.premioUltimaFatura.$el.getElementsByTagName('input')[0].value = item.premioUltimaFatura.toFixed(2);
      this.$refs.premioUltimos12Meses.$el.getElementsByTagName('input')[0].value = item.premioUltimos12Meses.toFixed(2);
      this.ramoModel = Object.assign({}, item)
      this.ramoModel.idTipoTaxa = item.idTipoTaxa.toString();
      this.dialogAdicionarRamo = true;
    },
    deletarItemRamo(item) {
      const index = this.dadosSeguroAnterior.ramos.indexOf(item)
      this.dadosSeguroAnterior.ramos.splice(index, 1);
    },
    editarItemRegra(item) {
      this.editedIndexRegra = this.dadosSeguroAnterior.regrasGerenciamento.indexOf(item)
      this.regraGerenciamentoModel = Object.assign({}, item)
      this.dialogAdicionarRegra = true
    },
    deletarItemRegra(item) {
      const index = this.dadosSeguroAnterior.regrasGerenciamento.indexOf(item)
      this.dadosSeguroAnterior.regrasGerenciamento.splice(index, 1)
    },
    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
      }).format(amount || 0);
    },
    tratamentoSalvarRamo() {
      if (this.ramoModel.idTipoRamo === 2 && this.ramoModel.posFranquia.length == 0) {
        this.snackbar.visivel = true;
        this.snackbar.sucesso = false;
        this.snackbar.mensagem = "POS/Franquia obrigatória ao selecionar RCF-DC";
        return
      }
      let objetoAux = { ...this.ramoModel }
      objetoAux.idTipoTaxa = parseInt(objetoAux.idTipoTaxa);
      objetoAux.valorTaxa = parseFloat(objetoAux.valorTaxa);
      if(this.editedIndexRamo  > -1) {
        Object.assign(this.dadosSeguroAnterior.ramos[this.editedIndexRamo], objetoAux)
      } else {
        this.dadosSeguroAnterior.ramos.push(objetoAux);
      }
      this.snackbar.visivel = true;
      this.snackbar.sucesso = true;
      this.snackbar.mensagem = "Ramo salvo.";
      this.tratamentoFecharDialogRamo();
    },
    salvarRegra() {
      let objetoAux = { ...this.regraGerenciamentoModel };
      if (this.editedIndexRegra > -1) {
        Object.assign(
          this.dadosSeguroAnterior.regrasGerenciamento[this.editedIndexRegra],
          objetoAux
        );
      }
      else {
        this.dadosSeguroAnterior.regrasGerenciamento.push(objetoAux);
      }
      this.dialogAdicionarRegra = false;
      this.snackbar.visivel = true;
      this.snackbar.sucesso = true;
      this.snackbar.mensagem = "Regra salva.";
      this.resetFormRegra();

    },
    ajustaOpcoes: function() {
      if (this.valorContadorComputed >= this.maximo) {
        this.menuProps.disabled = true
      } else {
        this.menuProps.disabled = false
      }
    },
    limparDadosRamo() {
      this.$refs.valorMedioAverbadoMes.$el.getElementsByTagName('input')[0].value = 0;
      this.$refs.limiteResponsabilidade.$el.getElementsByTagName('input')[0].value = 0;
      this.$refs.posFranquia.$el.getElementsByTagName('input')[0].value = 0;
      this.$refs.premioMinimoMensal.$el.getElementsByTagName('input')[0].value = 0;
      this.$refs.isUltimaFatura.$el.getElementsByTagName('input')[0].value = 0;
      this.$refs.premioUltimaFatura.$el.getElementsByTagName('input')[0].value = 0;
      this.$refs.premioUltimos12Meses.$el.getElementsByTagName('input')[0].value = 0;
      this.ramoModel.idTipoTaxa = null;
      this.ramoModel.valorTaxa = null;
      this.editedIndexRamo = -1;
      this.$refs.adicionarRamoForm.reset();
      this.$refs.adicionarRamoForm.resetValidation();
    },
    tratamentoFecharDialogRamo() {
      this.limparDadosRamo();
      this.dialogAdicionarRamo = false;
    },
    tratamentoFecharDialogSinistro() {
      this.resetForm();
      if(this.editedIndex > -1) {
        this.editedIndex = -1;
      }
      this.dialogSinistro = false;
    },
    tratamentoFecharDialogServico() {
      this.resetFormServico();
      if(this.editedIndex > -1) {

        this.editedIndex = -1;
      }
      this.dialogServico = false;
    },
    tratamentoFecharDialogRegra() {
      this.resetFormRegra();
      this.dialogAdicionarRegra = false;
    },
    limparCampos() {
      this.dadosSeguroAnterior.corretora = null
      this.dadosSeguroAnterior.seguradora = null
      this.dadosSeguroAnterior.vencimento = null
      this.dadosSeguroAnterior.contrataCobertura = false
      this.dadosSeguroAnterior.possuiCoberturaRoubo = false
      this.dadosSeguroAnterior.ramos.splice(0);
    },
    limparCamposServico() {
      this.dadosSeguroAnterior.contrataServicos.splice(0);
    },
    limparCamposSinistro() {
      this.dadosSeguroAnterior.sinistros.splice(0);
    },
    toLocaleDateString: function (val) {
        return CustomFormat.toLocaleDateString(val);
    },
    onDateChange: function() {
      this.dateInicio = this.objeto.data;
    },
    passoValido: function(){
      let isPassoValido = false

      if (this.dadosSeguroAnterior.container &&
        ((this.dadosSeguroAnterior.seguradora == "" || this.dadosSeguroAnterior.seguradora == null) ||
        (this.dadosSeguroAnterior.vencimento == "" || this.dadosSeguroAnterior.vencimento == null))) {
        isPassoValido = true
      }
      if (this.dadosSeguroAnterior.container &&
        this.dadosSeguroAnterior.contrataCobertura &&
        this.dadosSeguroAnterior.idCobertura == null) {
        isPassoValido = true
      }
      if (this.dadosSeguroAnterior.ocorreuSinistro && this.dadosSeguroAnterior.sinistros.length == 0) {
        isPassoValido = true
      }
      if (this.dadosSeguroAnterior.existeContrataServico && this.dadosSeguroAnterior.contrataServicos.length == 0) {
        isPassoValido = true
      }

      return isPassoValido
    },

    buscarTitulo(entity, list) {
      if (entity !== null && entity !== undefined) {
        const campo = list.find(
          item => item.id === entity || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },

    resetForm() {
      this.sinistroModel.idTipoEvento = null;
      this.sinistroModel.mercadoria = null;
      this.sinistroModel.tipoEvento = null;
      this.sinistroModel.data = new Date().toISOString().slice(0, 10);
      this.$refs.valorPrejuizo.$el.getElementsByTagName('input')[0].value = 0;
      this.editedIndex = -1;
      this.$refs.formEvento.resetValidation();
    },
    resetFormServico() {
      this.contrataServicoModel.idTipoServicoContratado = null;
      this.contrataServicoModel.gerenciadoraAtual = null;
      this.$refs.valorUltimaFatura.$el.getElementsByTagName('input')[0].value = 0;
      this.$refs.valorMedioFaturaMensal.$el.getElementsByTagName('input')[0].value = 0;
      this.editedIndex = -1;
      this.$refs.formServico.resetValidation();
    },
    resetFormRegra() {
      this.regraGerenciamentoModel.descricao = null;
      this.editedIndexRegra = -1;
      this.$refs.formRegra.resetValidation();
    },
    sendDatatoParent() {
      this.$emit("dadosSeguroAnterior", this.dadosSeguroAnterior);
    },

    editItem(item) {
      this.editedIndex = this.dadosSeguroAnterior.sinistros.indexOf(item);

      this.sinistroModel = Object.assign({}, item);
      this.$refs.valorPrejuizo.$el.getElementsByTagName('input')[0].value = item.valorPrejuizo.toFixed(2);

      this.dialogSinistro = true;
    },

    editItemServico(item) {
      this.editedIndex = this.dadosSeguroAnterior.contrataServicos.indexOf(item);

      this.$refs.valorUltimaFatura.$el.getElementsByTagName('input')[0].value = item.valorUltimaFatura.toFixed(2);
      this.$refs.valorMedioFaturaMensal.$el.getElementsByTagName('input')[0].value = item.valorMedioFaturaMensal.toFixed(2);

      this.contrataServicoModel = Object.assign({}, item);
      this.contrataServicoModel.gerenciadoraAtual = this.dadosSeguroAnterior.contrataServicos[this.editedIndex].gerenciadoraAtual;
      this. dialogServico= true;
    },

    textFim() {
      let data = new Date(this.dateFim).toISOString().slice(0, 10);
      return new Date(data).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        day: "numeric",
        month: "long",
        year: "numeric",


      });
    },

    deleteItem(item) {
      const index = this.dadosSeguroAnterior.sinistros.indexOf(item);
        this.dadosSeguroAnterior.sinistros.splice(index, 1);
    },
    deleteItemServico(item) {
      const index = this.dadosSeguroAnterior.contrataServicos.indexOf(item);
        this.dadosSeguroAnterior.contrataServicos.splice(index, 1);
    },

    salvarSinistros() {
      var sinistro = { ...this.sinistroModel };
      if (this.editedIndex > -1) {
        Object.assign(
          this.dadosSeguroAnterior.sinistros[this.editedIndex],
          sinistro
        );
      }
      else {
        this.dadosSeguroAnterior.sinistros.push(sinistro);
      }
      this.dialogSinistro = false;
      this.snackbar.visivel = true;
      this.snackbar.sucesso = true;
      this.snackbar.mensagem = "Evento salvo.";
      this.resetForm();

    },
    salvarServico() {
      var contrataServicos = { ...this.contrataServicoModel };
      if (this.editedIndex > -1) {
        Object.assign(
          this.dadosSeguroAnterior.contrataServicos[this.editedIndex],
          contrataServicos
        );
      }
      else {
        this.dadosSeguroAnterior.contrataServicos.push(contrataServicos);
      }
      this.dialogServico = false;
      this.snackbar.visivel = true;
      this.snackbar.sucesso = true;
      this.snackbar.mensagem = "Servico salvo.";
      this.resetFormServico();

    },
    validateFields() {
      if (
        this.dadosCadastrais.idModalidadeAtuacao.length &&
        this.dadosCadastrais.cnpj.length &&
        this.dadosCadastrais.razaoSocial.length
      ) {
        this.disableSubmitDadosCadastrais = true;
      }
    },
    buscarTituloSinistro(entity, list) {
      if (entity !== null && entity !== undefined) {
        const campo = list.find(
          item => item.titulo === entity || item.titulo === entity.titulo
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },
    // Método para permitir apenas 3 casas decimais após a vírgula
    limitaCasasDecimais($event) {
        if (this.ramoModel.valorTaxa != null && this.ramoModel.valorTaxa.indexOf('.') > -1 &&
            (this.ramoModel.valorTaxa.split('.')[1].length > 2)) {
              $event.preventDefault()
            }
      },
  },
};
</script>

<style>
.QuestionarioAnaliseRiscos .title-dialog-custom {
  color: #00456e;
  font-weight: bold;
  padding-bottom: 0;
  font-size: 18px;
}
.QuestionarioAnaliseRiscos .toolbar-custom {
  background-color: transparent;
}
.QuestionarioAnaliseRiscos .container-special {
  padding: 0 40px 40px 40px;
}
.dataTable {
  display: flex;
  justify-content: center;
}
.QuestionarioAnaliseRiscos .telaCondicoes{
  margin-top: 32px;
}
.texto-inform {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 0;
  color: #878682;
}
.titulo-modal {
  color: #00456e;
  font-size: 16px;
  font-weight: bold;
}
.flex-actions-ramo {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QARCondicoesSegurado.vue